import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, MenuItem } from "react-pro-sidebar";
import {
  IconDashboard,
  IconDocuments,
  IconEstimation,
  IconFinanceSide,
  IconPurchase,
} from "../../../icon/icons";
import { useClickAway } from "@uidotdev/usehooks";
import "./menuitems.scss";
import { useSocket } from "../../../context/SocketContext";
const MenuItems = ({ collapsed, checkSide, setCheckSide }) => {
  const [activeMenu, setActiveMenu] = useState(null);
  const { unreadCount } = useSocket();
  const location = useLocation();
  const source = location.state?.source;

  const filterRef = useClickAway(() => {
    if (!collapsed && checkSide) {
      setActiveMenu(null);
    }
  });

  const pathname = location.pathname;

  // Utility to check route group
  const isActive = (routes = []) => {
    return routes.some((route) => pathname.startsWith(route));
  };

  return (
    <Menu className="sidebar_icon_list" ref={filterRef}>
      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink to="/main-dashboard">
          <span className="sidebar-icon">
            {" "}
            <IconDashboard />
          </span>
          <p>Dashboard</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink
          to="/customers/client"
          className={
            pathname.startsWith("/customers/client") ||
            (pathname.startsWith("/customer/edit") && source === "client")
              ? "active"
              : ""
          }
        >
          <span className="sidebar-icon">
            {" "}
            <IconEstimation />
          </span>
          <p>Client</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink
          to="/customers/driver"
          className={
            pathname.startsWith("/customers/driver") ||
            (pathname.startsWith("/customer/edit") && source === "driver")
              ? "active"
              : ""
          }
        >
          <span className="sidebar-icon">
            {" "}
            <IconEstimation />
          </span>
          <p>Driver</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink
          to="/orders"
          className={
            isActive(["/orders", "/order/details", "/order/chat"])
              ? "active"
              : ""
          }
        >
          <span className="sidebar-icon">
            {" "}
            <IconPurchase />
          </span>
          <p>Orders</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink to="/faqs" className={isActive(["/faqs"]) ? "active" : ""}>
          <span className="sidebar-icon">
            {" "}
            <IconFinanceSide />
          </span>
          <p>Faqs</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink
          to="/pages"
          className={isActive(["/pages", "/page/edit"]) ? "active" : ""}
        >
          <span className="sidebar-icon">
            {" "}
            <IconDocuments />
          </span>
          <p>Pages</p>
        </NavLink>
      </MenuItem>

      <MenuItem className="new-sub-menu-active sidebar-page-menu">
        <NavLink
          to="/contact-support"
          className={isActive(["/contact-support"]) ? "active" : ""}
        >
          <span className="sidebar-icon">
            {" "}
            <IconDocuments />
          </span>

          <p className="menu-label">
            Contact Support
            {unreadCount > 0 && (
              <span className="unread-badge">{unreadCount}</span>
            )}
          </p>
        </NavLink>
      </MenuItem>
    </Menu>
  );
};

export default MenuItems;
